/** Job completion remains authoritative if the listing-status projection failed. */
export function refinementQueueInvalidations(event:string,payload:unknown):string[] {
  if(!['automation.job.queued','automation.job.completed','automation.job.failed'].includes(event)||
      !payload||typeof payload!=='object')return [];
  const job=payload as {workflow?:unknown;subjectType?:unknown};
  if(typeof job.workflow!=='string'||job.workflow.toUpperCase()!=='REFINE_LISTING'||job.subjectType!=='LISTING')return [];
  return ['page','listing-intake','page','image-builder','assets','listing-images'];
}

export const EVENT_INVALIDATION_MAP: Record<string, string[]> = {
  "review.created": ["page", "media-review", "page", "content-workbench"],
  "review.decision.updated": ["page", "media-review"],
  "review.completed": ["page", "media-review"],
  "listing.intake.updated": ["page", "listing-intake", "page", "image-builder", "page", "video-slideshow-builder",
    "page", "media-review", "page", "content-workbench", "final-approval-queue", "", "final-approval-detail", "", "listing", ""],
  // Supplier source handoffs do not alter MCP's media/review decisions. Keep
  // this narrowly scoped so a new supplier submission refreshes only the
  // active Intake read instead of every operational queue.
  "listing.intake.source.synced": ["page", "listing-intake", "listing", ""],
  "listing.refine.updated": ["page", "listing-intake", "page", "image-builder", "page", "content-workbench", "assets", "listing-images", "listing", ""],
  "listing.release.updated": ["final-approval-queue", "", "final-approval-detail", "", "listing", "", "page", "content-workbench"],
  "listing.media.approved": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", "", "listing", "", "assets", "listing-images", "assets", "listing-videos", "page", "video-slideshow-builder", "page", "image-builder"],
  "listing.media.processed": ["final-approval-queue", "", "final-approval-detail", "", "listing", "", "assets", "listing-images", "page", "image-builder"],
  "slideshow.render.completed": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", "", "assets", "listing-videos", "page", "video-slideshow-builder"],
  "slideshow.output.completed": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", "", "assets", "listing-videos"],
  "listing.published": [
    "page",
    "final-listing-approval",
    "dashboard",
    "command-center",
  ],
  "deal.updated": ["page", "dealz-control", "page", "livedealz-intake"],
  "deal.status.changed": ["page", "dealz-control"],
  "campaign.status.changed": ["page", "campaigns"],
  "supplier.status.changed": ["page", "suppliers-providers"],
  "user.updated": ["page", "roles-permissions"],
  "access-request.decided": ["page", "roles-permissions", "page", "inbox"],
  "content.version.created": ["page", "content-workbench", "listing", ""],
  "content.approved": ["page", "content-workbench", "listing", "", "final-approval-queue", "", "final-approval-detail", ""],
  "automation.job.queued": ["page", "automation"],
  "automation.job.completed": ["page", "automation"],
  "automation.job.failed": ["page", "automation"],
  "work_item.assigned": ["operations", "work-items", "page", "inbox"],
  "inbox.item.created": ["page", "inbox", "dashboard", "app-shell"],
  "platform.setting.updated": ["page", "platform-settings"],
  "platform.settings.changed": ["page", "platform-settings"],
  "asset.created": ["page", "user-asset-libraries"],
  "media_project.completed": [
    "page",
    "image-builder",
    "page",
    "video-slideshow-builder",
  ],
};
